<template>
    <div>
        <LeagueViewBlock
                v-if="showLive === true && leagueLiveMatchesCount > 0"
                :feed="feedLive"
                :league-key="leagueKey"
                :league-name="leagueName"
                :is-live="true"
                :match-counts="leagueLiveMatchesCount"
                @refreshFeed="refreshFeed()"
        />
        <LeagueViewBlock
                v-if="leagueNotLiveMatchesCount > 0"
                :feed="feedNotLive"
                :league-key="leagueKey"
                :league-name="leagueName"
                :is-live="false"
                :match-counts="leagueNotLiveMatchesCount"
                @refreshFeed="refreshFeed()"
        />
    </div>
</template>

<script>
    import LeagueViewBlock from "./LeagueViewBlock";
    import { mapGetters } from 'vuex'
    const _ = require('lodash')

    export default {
        name: 'LeagueView',
        components: {
            LeagueViewBlock,
        },
        props:{
            feed : Object,
            leagueName : String,
            leagueKey : String,
        },
        computed: {
            ...mapGetters({
                showLive: 'settings/showLive',
            })
        },
        methods: {
            refreshFeed() {
                this.$emit('refreshFeed')
            },
            fetchMatchInformationForMatch(match) {
                let firstMarketKey = Object.keys(match)[0]
                let firstMarket = match[firstMarketKey]
                let firstKey = Object.keys(firstMarket)[0]
                return firstMarket[firstKey][0]
            },
        },
        data() {
            return {
                feedLive:{},
                feedNotLive:{},
                leagueLiveMatchesCount:0,
                leagueNotLiveMatchesCount:0,
            }
        },
        mounted() {
            _.forEach(this.feed, (match, key) => {
                let matchInfo = this.fetchMatchInformationForMatch(match)
                if(matchInfo!==undefined){
                    if(matchInfo.is_live === "1"){
                        _.assign(this.feedLive, {[key] : {...match, matchInfo}})
                    }
                    else{
                        _.assign(this.feedNotLive, {[key] : {...match, matchInfo}})
                    }
                }
            })
            this.leagueLiveMatchesCount = Object.keys(this.feedLive).length
            this.leagueNotLiveMatchesCount = Object.keys(this.feedNotLive).length
        }
    }
</script>